import { TFunction } from 'i18next';
import { TeamViewMode } from '../enums';

type Args = {
  t: TFunction<'translation', undefined>;
  membersCounter: number;
  departmentsCounter: number;
};

export default function getTableTabs({
  t,
  membersCounter = 0,
  departmentsCounter = 0,
}: Args) {
  return [
    {
      label: t('team-details'),
      value: TeamViewMode.ViewDetails,
    },
    {
      label: t('members'),
      value: TeamViewMode.ViewMembers,
      counter: membersCounter,
    },
    {
      label: t('departments'),
      value: TeamViewMode.ViewDepartments,
      counter: departmentsCounter,
    },
  ];
}
